import { Component } from '@angular/core';
import {AppBreadcrumbService} from '../app.breadcrumb.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-help',
    templateUrl: './app.help.component.html',
})
export class AppHelpComponent {

    constructor(private breadcrumbService: AppBreadcrumbService) {
        this.breadcrumbService.setItems([
            this.breadcrumbService.help,
        ]);
    }

    NavToFAQs() {
        var url = environment.imageBase.concat('/', "resourcecenter/NAIAppHelp.pdf");
        window.open(url, "_blank");
    }
}
